import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <section className="py-28 md:py-36 px-4 md:px-8 lg:px-20 bg-background-100">
      <div className="max-w-[720px] mx-auto text-center">
        <p className="text-sm tracking-[0.05em] uppercase text-foreground-500 mb-6">
          {t('about.label')}
        </p>
        <p className="text-[28px] md:text-[36px] font-heading font-medium text-foreground-950 leading-[1.5]">
          {t('about.text')}
        </p>
      </div>
    </section>
  );
}